import React, { FC, useState } from 'react'
import { FormModelComponent } from 'Pages/landings/newLandings/common/components'
import { IconTooltip } from 'Pages/landings/newLandings/products/rboPage/Form/IconTooltip'
import { Wrapper, TitleModel, SubTitleModel } from './styled'

interface ComponentProps {
	className?: string
}

export const FormComponent: FC<ComponentProps> = ({ className }) => {
	const [isLoading, setIsLoading] = useState(false)
	const changeLoading = () => setIsLoading((prevLoading) => !prevLoading)

	return (
		<Wrapper id="form" className={className}>
			<FormModelComponent
				isInn
				isKnowInn
				isProduct
				isLoading={isLoading}
				changeLoading={changeLoading}
				icon={<IconTooltip />}
			>
				<TitleModel>Оставьте заявку на регистрацию бизнеса</TitleModel>
				<SubTitleModel>Наш менеджер свяжется с вами для уточнения деталей</SubTitleModel>
			</FormModelComponent>
		</Wrapper>
	)
}
